export const FEEDBACK_QUALITY_GET_REQUEST = 'FEEDBACK_QUALITY_GET_REQUEST';
export const FEEDBACK_QUALITY_GET_SUCCESS = 'FEEDBACK_QUALITY_GET_SUCCESS';
export const FEEDBACK_QUALITY_GET_FAILURE = 'FEEDBACK_QUALITY_GET_FAILURE';
export const FEEDBACK_QUALITY_GET = 'FEEDBACK_QUALITY_GET';

export const FEEDBACK_QUALITY_DELETE_REQUEST = 'FEEDBACK_QUALITY_DELETE_REQUEST';
export const FEEDBACK_QUALITY_DELETE_SUCCESS = 'FEEDBACK_QUALITY_DELETE_SUCCESS';
export const FEEDBACK_QUALITY_DELETE_FAILURE = 'FEEDBACK_QUALITY_DELETE_FAILURE';
export const FEEDBACK_QUALITY_CLOSE_DELETE_DIALOG = 'FEEDBACK_QUALITY_CLOSE_DELETE_DIALOG';
export const FEEDBACK_QUALITY_DELETE = 'FEEDBACK_QUALITY_DELETE';

export const FEEDBACK_QUALITY_AUTOSAVE_REQUEST = 'FEEDBACK_QUALITY_AUTOSAVE_REQUEST';
export const FEEDBACK_QUALITY_AUTOSAVE_SUCCESS = 'FEEDBACK_QUALITY_AUTOSAVE_SUCCESS';
export const FEEDBACK_QUALITY_AUTOSAVE_FAILURE = 'FEEDBACK_QUALITY_AUTOSAVE_FAILURE';
export const FEEDBACK_QUALITY_AUTOSAVE = 'FEEDBACK_QUALITY_AUTOSAVE';

export const AWAIT_FEEDBACK_QUALITY_AUTOSAVE_RESPONSE = 'AWAIT_FEEDBACK_QUALITY_AUTOSAVE_RESPONSE';

export const FEEDBACK_QUALITY_SUBMIT_REQUEST = 'FEEDBACK_QUALITY_SUBMIT_REQUEST';
export const FEEDBACK_QUALITY_SUBMIT_SUCCESS = 'FEEDBACK_QUALITY_SUBMIT_SUCCESS';
export const FEEDBACK_QUALITY_SUBMIT_FAILURE = 'FEEDBACK_QUALITY_SUBMIT_FAILURE';
export const FEEDBACK_QUALITY_SUBMIT = 'FEEDBACK_QUALITY_SUBMIT';

export const FEEDBACK_QUALITY_ADD_REQUEST = 'FEEDBACK_QUALITY_ADD_REQUEST';
export const FEEDBACK_QUALITY_ADD_SUCCESS = 'FEEDBACK_QUALITY_ADD_SUCCESS';
export const FEEDBACK_QUALITY_ADD_FAILURE = 'FEEDBACK_QUALITY_ADD_FAILURE';
export const FEEDBACK_QUALITY_ADD = 'FEEDBACK_QUALITY_ADD';

export const CLEAR_AUTOSAVE_NOTIFICATION = 'CLEAR_AUTOSAVE_NOTIFICATION';

export const OTHER_FEEDBACK_GET = 'OTHER_FEEDBACK_GET';

export const OTHER_FEEDBACK_READ = 'OTHER_FEEDBACK_READ';
export const OTHER_FEEDBACK_READ_REQUEST = 'OTHER_FEEDBACK_READ_REQUEST';
export const OTHER_FEEDBACK_READ_SUCCESS = 'OTHER_FEEDBACK_READ_SUCCESS';
export const OTHER_FEEDBACK_READ_FAILURE = 'OTHER_FEEDBACK_READ_FAILURE';
